import {LayerId} from '@mc/react-mapio';
import {CatalogItemVO} from '../api';

export type MapViewState = Record<
    string,
    {
        zoom?: number;
        center?: [number, number];
        activeLayers?: LayerId[];
        backgroundLayer?: LayerId;
        foregroundLayer?: LayerId;
    }
>;

export const CACHE_KEY_MAP_SETTINGS = 'mapio.mapViewState';
export const CACHE_KEY_CURRENT_TOPIC = 'mapio.currentTopic';

/**
 * Rekurzivně prohledá strom katalogu a najde vrstvu podle layerId.
 * @param item - aktuální item v katalogu
 * @param layerId - ID vrstvy, kterou hledáme
 * @returns true, pokud byla vrstva nalezena
 */
function findLayerInCatalogTree(item: CatalogItemVO, layerId: number): boolean {
    // Zkontroluj aktuální item
    if (item.layerId === layerId) {
        return true;
    }

    // Rekurzivně prohledej děti
    if (item.children && Array.isArray(item.children)) {
        for (const child of item.children) {
            if (findLayerInCatalogTree(child, layerId)) {
                return true;
            }
        }
    }

    return false;
}

/**
 * Ověří, zda se zadané layerId nachází ve stromu katalogu.
 * @param catalogRoot - kořenový katalog vrstev (pole CatalogItemVO)
 * @param layerId - ID vrstvy, kterou hledáme
 * @returns true, pokud se vrstva nachází v katalogu
 */
export const isLayerInCatalog = (catalogRoot: CatalogItemVO[] | undefined, layerId: number | string): boolean => {
    if (!catalogRoot || !Array.isArray(catalogRoot)) return false;

    const searchLayerId = typeof layerId === 'string' ? Number.parseInt(layerId, 10) : layerId;
    if (Number.isNaN(searchLayerId)) return false;

    // Prohledej všechny top-level items v katalogu
    for (const item of catalogRoot) {
        if (findLayerInCatalogTree(item, searchLayerId)) {
            return true;
        }
    }

    return false;
};
